var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.2,
    height: 95.2,
    viewBox: "0 0 95.2 95.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M120.222-814.788l24.038-15.351a2.562,2.562,0,0,0,1.309-2.261,2.562,2.562,0,0,0-1.309-2.261l-24.038-15.351a2.391,2.391,0,0,0-2.737-.179,2.584,2.584,0,0,0-1.428,2.44v30.7a2.584,2.584,0,0,0,1.428,2.44A2.391,2.391,0,0,0,120.222-814.788ZM127.6-784.8a46.058,46.058,0,0,1-18.445-3.748,48.281,48.281,0,0,1-15.173-10.234,48.282,48.282,0,0,1-10.234-15.173A46.058,46.058,0,0,1,80-832.4a46.35,46.35,0,0,1,3.749-18.564,47.57,47.57,0,0,1,10.234-15.113,48.794,48.794,0,0,1,15.173-10.175A46.056,46.056,0,0,1,127.6-880a46.35,46.35,0,0,1,18.564,3.749,48.069,48.069,0,0,1,15.113,10.175,48.068,48.068,0,0,1,10.175,15.113A46.35,46.35,0,0,1,175.2-832.4a46.057,46.057,0,0,1-3.749,18.445,48.8,48.8,0,0,1-10.175,15.173,47.57,47.57,0,0,1-15.113,10.234A46.352,46.352,0,0,1,127.6-784.8Zm0-7.14a38.933,38.933,0,0,0,28.679-11.841A39.09,39.09,0,0,0,168.06-832.4a39.033,39.033,0,0,0-11.781-28.679A39.033,39.033,0,0,0,127.6-872.86a39.09,39.09,0,0,0-28.62,11.781A38.933,38.933,0,0,0,87.14-832.4a38.99,38.99,0,0,0,11.841,28.62A38.99,38.99,0,0,0,127.6-791.94ZM127.6-832.4Z",
    transform: "translate(-80 880)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.c878888038b85b86aa3848f329a5f46e.svg";
export { ForwardRef as ReactComponent };